import { GridItem } from "ui-library/layouts";

import { UserVerification } from "../containers/";

export const VerificationTab = () => (
    <GridItem xs={12}>
        <UserVerification />
    </GridItem>
);
